import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { LabeledRadio } from '@nextiva/next-ui';

import { optionPropTypes } from 'sharedParts/config/blockConfig/settings/optionListPropTypes';

import MatrixCheckableInputGroup from '../MatrixCheckableInputGroup/MatrixCheckableInputGroup';
import propTypeBlockStyling from '../../../../../../domains/styling/config/editorBlock/PropTypes/blockStyling';

export default class MatrixRadioGroupField extends Component {
  static propTypes = {
    option: optionPropTypes,
    input: PropTypes.shape({
      name: PropTypes.string.isRequired,
      value: PropTypes.object,
      onChange: PropTypes.func.isRequired,
    }).isRequired,
    meta: PropTypes.object.isRequired,
    labelList: PropTypes.array,
    form: PropTypes.string.isRequired,
    styling: propTypeBlockStyling,
  };

  handleAnswer = label => () => {
    const answer = {
      [label.id]: {
        option: this.props.option.value,
        selectedValue: label.value,
      },
    };
    this.props.input.onChange(answer);
  };

  render() {
    const {
      input: { value },
      meta,
      form,
      option,
      labelList,
      styling,
    } = this.props;

    return (
      <MatrixCheckableInputGroup
        handleChange={this.handleAnswer}
        inputCellRenderer={LabeledRadio}
        option={option}
        labelList={labelList}
        value={value}
        meta={meta}
        form={form}
        styling={styling}
      />
    );
  }
}
